<template>
  <div id="FactTaxPlan" class="section">
    <div class="columns is-multiline is-mobile">
      <!-- TOTAL INCOME INFO. -->
      <div class="column is-12">
        <p class="title is-4 has-text-left">ข้อมูลรายได้ต่อปี</p>
        <div class="columns has-text-left is-multiline">
          <!-- 0 -->
          <div class="column is-12">
            <div class="columns is-multiline is-align-end">
              <div class="column is-4">
                <b-field label="รายได้ต่อปี">
                  <b-input type="number" min="0" v-model="total_income" />
                </b-field>
              </div>
              <div class="column is-8">
                <b-field label="คำแนะนำเบื้องต้น">
                  <b-input type="textarea" min="0" v-model="recommendation" />
                </b-field>
                <p v-if="isExceedTaxMaxCap" style="color: #ff3860">
                  *ท่านได้แนะนำเพิ่มเติม เกินวงเงิน 500,000 บาท
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- TOTAL TAX DEDUCTION INFO. -->
      <div class="column is-12">
        <p class="title is-4 has-text-left">ข้อมูลการลดหย่อนภาษี</p>
        <div class="columns has-text-left is-multiline">
          <!-- 1 : LIFE INSURANCE-->
          <div class="column is-12">
            <b-field label="ประกันชีวิตและสุขภาพ"> </b-field>
            <div class="columns is-multiline is-align-end">
              <div class="column is-4">
                <b-field
                  :label="
                    percent_life > 0
                      ? 'ปัจจุบันที่มี ' + percent_life + '%'
                      : 'ปัจจุบันที่มี'
                  "
                >
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="ปัจจุบันที่มี"
                    v-model="life_current"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field
                  :label="
                    percent_life_adjust > 0
                      ? 'แนะนำเพิ่มเติม ' + percent_life_summ
                      : 'แนะนำเพิ่มเติม'
                  "
                >
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="แนะนำเพิ่มเติม"
                    v-model="life_adjust"
                  />
                </b-field>
              </div>
            </div>
          </div>
          <!-- 2 : PENSION INSURANCE-->
          <div class="column is-12">
            <b-field label="ประกันบำนาญ"> </b-field>
            <div class="columns is-multiline is-align-end">
              <div class="column is-4">
                <b-field
                  :label="
                    percent_pension > 0
                      ? 'ปัจจุบันที่มี ' + percent_pension + '%'
                      : 'ปัจจุบันที่มี'
                  "
                >
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="ปัจจุบันที่มี"
                    v-model="pension_current"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field
                  :label="
                    percent_pension_adjust > 0
                      ? 'แนะนำเพิ่มเติม ' + percent_pension_summ
                      : 'แนะนำเพิ่มเติม'
                  "
                >
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="แนะนำเพิ่มเติม"
                    v-model="pension_adjust"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="สิทธิ์ภาษีสูงสุด">
                  <b-input
                    :disabled="pension_max"
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="สิทธิ์ภาษีสูงสุด"
                    v-model="pension_max"
                  />
                </b-field>
              </div>
            </div>
          </div>
          <!-- 3 : SSF -->
          <div class="column is-12">
            <b-field label="Super Saving Fund (SSF)"> </b-field>
            <div class="columns is-multiline is-align-end">
              <div class="column is-4">
                <b-field
                  :label="
                    percent_fund > 0
                      ? 'ปัจจุบันที่มี ' + percent_fund + '%'
                      : 'ปัจจุบันที่มี'
                  "
                >
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="ปัจจุบันที่มี"
                    v-model="fund_current"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field
                  :label="
                    percent_fund_adjust > 0
                      ? 'แนะนำเพิ่มเติม ' + percent_fund_summ
                      : 'แนะนำเพิ่มเติม'
                  "
                >
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="แนะนำเพิ่มเติม"
                    v-model="fund_adjust"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="สิทธิ์ภาษีสูงสุด">
                  <b-input
                    :disabled="fund_max"
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="สิทธิ์ภาษีสูงสุด"
                    v-model="fund_max"
                  />
                </b-field>
              </div>
            </div>
          </div>
          <!-- 4 : RMF -->
          <div class="column is-12">
            <b-field label="Retirement Fund (RMF)"> </b-field>
            <div class="columns is-multiline is-align-end">
              <div class="column is-4">
                <b-field
                  :label="
                    percent_rmf > 0
                      ? 'ปัจจุบันที่มี ' + percent_rmf + '%'
                      : 'ปัจจุบันที่มี'
                  "
                >
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="ปัจจุบันที่มี"
                    v-model="rmf_current"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field
                  :label="
                    percent_rmf_adjust > 0
                      ? 'แนะนำเพิ่มเติม ' + percent_rmf_summ
                      : 'แนะนำเพิ่มเติม'
                  "
                >
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="แนะนำเพิ่มเติม"
                    v-model="rmf_adjust"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="สิทธิ์ภาษีสูงสุด">
                  <b-input
                    :disabled="rmf_max"
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="สิทธิ์ภาษีสูงสุด"
                    v-model="rmf_max"
                  />
                </b-field>
              </div>
            </div>
          </div>
          <!-- 5 : PVD -->
          <div class="column is-12">
            <b-field label="Provident Fund (PVD)"> </b-field>
            <div class="columns is-multiline is-align-end">
              <div class="column is-4">
                <b-field
                  :label="
                    percent_pvd > 0
                      ? 'ปัจจุบันที่มี ' + percent_pvd + '%'
                      : 'ปัจจุบันที่มี'
                  "
                >
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="ปัจจุบันที่มี"
                    v-model="pvd_current"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field
                  :label="
                    percent_pvd_adjust > 0
                      ? 'แนะนำเพิ่มเติม ' + percent_pvd_summ
                      : 'แนะนำเพิ่มเติม'
                  "
                >
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="แนะนำเพิ่มเติม"
                    v-model="pvd_adjust"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="% หักจากเงินเดือน">
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="% หักจากเงินเดือน"
                    v-model="pvd_rate"
                  />
                </b-field>
              </div>
            </div>
          </div>
          <!-- 6 -->
          <div class="column is-12">
            <b-field label="อื่นๆ"> </b-field>
            <div class="columns is-multiline is-align-end">
              <div class="column is-4">
                <b-field
                  :label="
                    percent_others > 0
                      ? 'ปัจจุบันที่มี ' + percent_others + '%'
                      : 'ปัจจุบันที่มี'
                  "
                >
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="ปัจจุบันที่มี"
                    v-model="others_current"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field
                  :label="
                    percent_others_adjust > 0
                      ? 'แนะนำเพิ่มเติม ' + percent_others_summ
                      : 'แนะนำเพิ่มเติม'
                  "
                >
                  <b-input
                    type="number"
                    min="0"
                    custom-class="prompt-font"
                    placeholder="แนะนำเพิ่มเติม"
                    v-model="others_adjust"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="สิทธิ์ภาษีสูงสุด">
                  <b-input
                    type="text"
                    custom-class="prompt-font"
                    placeholder="สิทธิ์ภาษีสูงสุด"
                    v-model="others_max"
                  />
                </b-field>
              </div>
              <div class="column is-12">
                <b-field label="Note">
                  <b-input
                    type="text"
                    custom-class="prompt-font"
                    placeholder="Note"
                    v-model="others_note"
                  />
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="btn-mt">
      <div class="columns is-centered">
        <div class="column is-2-desktop is-4-tablet is-12-mobile">
          <b-button
            outlined
            expanded
            class="prompt-font"
            @click.prevent="backwardStep()"
            >ย้อนกลับ
          </b-button>
        </div>
        <div v-if="edited" class="column is-2-desktop is-4-tablet is-12-mobile">
          <b-button
            outlined
            expanded
            type="is-primary"
            class="prompt-font"
            @click.prevent="updateFactInfoState()"
          >
            บันทึก
          </b-button>
        </div>
        <div class="column is-2-desktop is-4-tablet is-12-mobile">
          <b-button
            expanded
            type="is-primary"
            class="prompt-font"
            @click.prevent="saveFactInfoState()"
          >
            ต่อไป
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "FactTaxPlan",
  props: ["existing_factinfo", "edited"],
  computed: {
    ...mapState(["client", "factsheet_tax_planning"]),
    percent_life: function() {
      return this.calculatePercentFromTotalIncome(this.life_current);
    },
    percent_life_adjust: function() {
      return this.calculatePercentFromTotalIncome(this.life_adjust);
    },
    percent_life_summ: function() {
      return this.calculateDiffPercent(
        this.percent_life,
        this.percent_life_adjust
      );
    },
    percent_pension: function() {
      return this.calculatePercentFromTotalIncome(this.pension_current);
    },
    percent_pension_adjust: function() {
      return this.calculatePercentFromTotalIncome(this.pension_adjust);
    },
    percent_pension_summ: function() {
      return this.calculateDiffPercent(
        this.percent_pension,
        this.percent_pension_adjust
      );
    },
    percent_fund: function() {
      return this.calculatePercentFromTotalIncome(this.fund_current);
    },
    percent_fund_adjust: function() {
      return this.calculatePercentFromTotalIncome(this.fund_adjust);
    },
    percent_fund_summ: function() {
      return this.calculateDiffPercent(
        this.percent_fund,
        this.percent_fund_adjust
      );
    },
    percent_rmf: function() {
      return this.calculatePercentFromTotalIncome(this.rmf_current);
    },
    percent_rmf_adjust: function() {
      return this.calculatePercentFromTotalIncome(this.rmf_adjust);
    },
    percent_rmf_summ: function() {
      return this.calculateDiffPercent(
        this.percent_rmf,
        this.percent_rmf_adjust
      );
    },
    percent_pvd: function() {
      return this.calculatePercentFromTotalIncome(this.pvd_current);
    },
    percent_pvd_adjust: function() {
      return this.calculatePercentFromTotalIncome(this.pvd_adjust);
    },
    percent_pvd_summ: function() {
      return this.calculateDiffPercent(
        this.percent_pvd,
        this.percent_pvd_adjust
      );
    },
    percent_others: function() {
      return this.calculatePercentFromTotalIncome(this.others_current);
    },
    percent_others_adjust: function() {
      return this.calculatePercentFromTotalIncome(this.others_adjust);
    },
    percent_others_summ: function() {
      return this.calculateDiffPercent(
        this.percent_others,
        this.percent_others_adjust
      );
    },
    pension_max: function() {
      if (this.total_income) {
        const max_value = 200000;
        const current_value = +this.total_income * 0.15;
        return current_value > max_value ? max_value : current_value;
      } else {
        return null;
      }
    },
    fund_max: function() {
      if (this.total_income) {
        const max_value = 200000;
        const current_value = +this.total_income * 0.3;
        return current_value > max_value ? max_value : current_value;
      } else {
        return null;
      }
    },
    rmf_max: function() {
      if (this.total_income) {
        const max_value = 500000;
        const current_value = +this.total_income * 0.3;
        return current_value > max_value ? max_value : current_value;
      } else {
        return null;
      }
    },
    isExceedTaxMaxCap: function() {
      const pension = this.pension_adjust
        ? +this.pension_adjust + +this.pension_current
        : +this.pension_current;
      const fund = this.fund_adjust
        ? +this.fund_adjust + +this.fund_current
        : +this.fund_current;
      const rmf = this.rmf_adjust
        ? +this.rmf_adjust + +this.rmf_current
        : +this.rmf_current;
      const pvd = this.pvd_adjust
        ? +this.pvd_adjust + +this.pvd_current
        : +this.pvd_current;
      const total = pension + fund + rmf + pvd;

      if (total > 500000) {
        if (!this.is_display_snack_exceed) {
          this.$buefy.snackbar.open({
            duration: 5000,
            message: "ท่านได้แนะนำเพิ่มเติม เกินวงเงิน 500,000 บาท",
            type: "is-danger",
            actionText: "OK"
          });
        }
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    isExceedTaxMaxCap: function(val) {
      this.is_display_snack_exceed = val;
    }
  },
  data() {
    return {
      is_display_snack_exceed: false,
      total_income: null,
      recommendation: null,
      life_current: null,
      life_adjust: null,
      pension_current: null,
      pension_adjust: null,
      fund_current: null,
      fund_adjust: null,
      rmf_current: null,
      rmf_adjust: null,
      pvd_current: null,
      pvd_adjust: null,
      pvd_rate: null,
      others_current: null,
      others_adjust: null,
      others_max: null,
      others_note: null
    };
  },
  methods: {
    ...mapMutations({
      setFactSheetTaxPlanning: "SET_FACTSHEET_TAX_PLANNING"
    }),
    calculatePercentFromTotalIncome(input) {
      if (this.total_income) {
        return ((input / this.total_income) * 100).toFixed(2);
      } else {
        return null;
      }
    },
    calculateDiffPercent(existing, adjusted) {
      let sum_percent = (+existing + +adjusted).toFixed(2);
      if (+adjusted >= 0) {
        return sum_percent + "% (+" + adjusted + "%)";
      } else {
        return sum_percent + "%";
      }
    },
    /* For Display Existing Information */
    setUpTaxInfo(tax_info) {
      this.total_income = tax_info.total_income;
      this.recommendation = tax_info.recommendation_note;

      this.life_current = tax_info.life.current;
      this.life_adjust = tax_info.life.adjust;

      this.pension_current = tax_info.pension.current;
      this.pension_adjust = tax_info.pension.adjust;

      this.fund_current = tax_info.ssf.current;
      this.fund_adjust = tax_info.ssf.adjust;

      this.rmf_current = tax_info.rmf.current;
      this.rmf_adjust = tax_info.rmf.adjust;

      this.pvd_current = tax_info.provident_fund.current;
      this.pvd_adjust = tax_info.provident_fund.adjust;
      this.pvd_rate = tax_info.provident_fund.rate;

      this.others_current = tax_info.etc.current;
      this.others_adjust = tax_info.etc.adjust;
      this.others_max = tax_info.etc.max;
      this.others_note = tax_info.etc.text;
    },
    /* Button Action Handler */
    saveFactInfoState: function() {
      if (!this.edited) {
        let plan_tax = this.createFactInfoTaxObject();
        this.setFactSheetTaxPlanning(plan_tax);
      }
      this.$emit("form_completed");
    },
    updateFactInfoState: function() {
      if (this.edited) {
        let plan_tax = this.createFactInfoTaxObject();
        this.setFactSheetTaxPlanning(plan_tax);
        this.$emit("existing_sheet_updated");
      }
    },
    backwardStep: function() {
      this.$emit("back");
    },
    /* API & PARAMS*/
    createFactInfoTaxObject: function() {
      const plan_tax = {
        total_income: +this.total_income,
        life: {
          adjust: +this.life_adjust,
          current: +this.life_current
        },
        pension: {
          adjust: +this.pension_adjust,
          current: +this.pension_current
        },
        ssf: {
          adjust: +this.fund_adjust,
          current: +this.fund_current
        },
        rmf: {
          adjust: +this.rmf_adjust,
          current: +this.rmf_current
        },
        provident_fund: {
          adjust: +this.pvd_adjust,
          current: +this.pvd_current,
          rate: +this.pvd_rate
        },
        etc: {
          adjust: +this.others_adjust,
          current: +this.others_current,
          max: +this.others_max,
          text: this.others_note
        }
      };
      if (this.recommendation) {
        if (this.isExceedTaxMaxCap && this.recommendation) {
          plan_tax.recommendation_note =
            this.recommendation +
            "\n*ท่านได้แนะนำเพิ่มเติม เกินวงเงิน 500,000 บาท";
        } else {
          plan_tax.recommendation_note = this.recommendation.replace(
            "\n*ท่านได้แนะนำเพิ่มเติม เกินวงเงิน 500,000 บาท",
            ""
          );
        }
      }
      return plan_tax;
    }
  },
  beforeMount() {
    if (this.edited) {
      this.setUpTaxInfo(this.factsheet_tax_planning);
    }
  }
};
</script>
